import React from 'react'

export const ChevronDown = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      width='20px'
      height='20px'
    >
      <path
        fillRule='evenodd'
        d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const ChevronUp = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      width='20px'
      height='20px'
    >
      <path
        fillRule='evenodd'
        d='M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const ChevronLeft = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      width='20px'
      height='20px'
    >
      <path
        fillRule='evenodd'
        d='M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const ChevronRight = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      width='20px'
      height='20px'
    >
      <path
        fillRule='evenodd'
        d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const ChevronLeftBig = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='45'
      height='45'
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.7417 13.5407L20.7866 22.4958L29.7417 31.4509L26.978 34.2146L15.2593 22.4958L26.978 10.7771L29.7417 13.5407Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const ChevronRightBig = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='45'
      height='45'
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.2583 31.4593L24.2134 22.5042L15.2583 13.5491L18.022 10.7854L29.7407 22.5042L18.022 34.2229L15.2583 31.4593Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const ArrowRight = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='10'
      height='8'
      viewBox='0 0 10 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.60489 0.5697L8.61795 3.61999C8.69842 3.70351 8.74464 3.81608 8.74464 3.93591C8.74464 4.05574 8.69862 4.16904 8.6173 4.25147L5.60424 7.30176C5.42513 7.46735 5.18032 7.4611 5.02282 7.28691C4.86607 7.11442 4.87196 6.83754 5.03673 6.67068L7.3083 4.37167L1.48624 4.37167C1.2594 4.37167 1.0752 4.17648 1.0752 3.95225C1.0752 3.72802 1.2594 3.50016 1.48624 3.50016L7.30864 3.50016L5.03686 1.20155C4.87208 1.0353 4.86619 0.758345 5.02295 0.585314C5.18032 0.409922 5.42513 0.404475 5.60489 0.5697Z'
        fill='black'
      />
    </svg>
  )
}

export const Pencil = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='14'
      height='14'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.3408 1.97789L16.0221 0.65918C15.583 0.219727 15.0071 0 14.4313 0C13.8554 0 13.2795 0.219727 12.8401 0.658828L0.451791 13.0472L0.00530851 17.0627C-0.0509412 17.5683 0.347377 18 0.842024 18C0.873312 18 0.904601 17.9982 0.936593 17.9947L4.94931 17.5514L17.3411 5.15953C18.2197 4.28098 18.2197 2.85645 17.3408 1.97789V1.97789ZM4.43287 16.477L1.1623 16.8395L1.52651 13.564L10.8039 4.2866L13.7137 7.19648L4.43287 16.477V16.477ZM16.5455 4.3643L14.509 6.4009L11.5991 3.49102L13.6357 1.45441C13.848 1.24207 14.1307 1.125 14.4313 1.125C14.7318 1.125 15.0141 1.24207 15.2268 1.45441L16.5455 2.77312C16.9839 3.21187 16.9839 3.92555 16.5455 4.3643Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const InformationCircle = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      height='20px'
      width='20px'
    >
      <path
        fillRule='evenodd'
        d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const Information = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='14'
      height='14'
      viewBox='0 0 7 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.22537 2.57055C1.96712 2.30108 1.838 1.98108 1.838 1.61055C1.838 1.24003 1.96712 0.925641 2.22537 0.667395C2.49484 0.397921 2.81484 0.263184 3.18537 0.263184C3.55589 0.263184 3.87028 0.397921 4.12852 0.667395C4.398 0.925641 4.53273 1.24003 4.53273 1.61055C4.53273 1.98108 4.398 2.30108 4.12852 2.57055C3.87028 2.8288 3.55589 2.95792 3.18537 2.95792C2.81484 2.95792 2.49484 2.8288 2.22537 2.57055ZM2.86537 4.22108C3.9208 4.22108 4.44852 4.67582 4.44852 5.58529V11.0253C4.44852 11.3284 4.52151 11.5699 4.66747 11.7495C4.81344 11.9179 5.038 12.0021 5.34116 12.0021C5.64431 12.0021 5.99238 11.8393 6.38537 11.5137L6.68852 11.9179C5.79028 12.7376 4.89203 13.1474 3.99379 13.1474C2.61273 13.1474 1.92221 12.3221 1.92221 10.6716V5.0295C1.30466 5.18669 0.833085 5.46178 0.507471 5.85476L0.0527344 5.33266C0.378348 4.99582 0.788173 4.72634 1.28221 4.52424C1.78747 4.32213 2.31519 4.22108 2.86537 4.22108Z'
        fill='white'
      />
    </svg>
  )
}

export const Bookmark = ({ classes }) => {
  return (
    <svg
      className={classes}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      width='20px'
      height='20px'
      fill='currentColor'
    >
      <path d='M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z' />
    </svg>
  )
}

export const Close = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  )
}

export const CloseMedium = ({ classes }) => {
  return (
    <svg
      className={'h-5 w-5' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  )
}

export const CloseSmall = ({ classes }) => {
  return (
    <svg
      className={'h-3 w-3' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  )
}

export const Download = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
      />
    </svg>
  )
}

export const CheckMark = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M5 13l4 4L19 7'
      />
    </svg>
  )
}

export const Plus = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M12 6v6m0 0v6m0-6h6m-6 0H6'
      />
    </svg>
  )
}

export const PlusLarge = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.4606 15.9999H1.74024M15.6004 2.13965L15.6004 29.8601L15.6004 2.13965Z'
        stroke='#5E5E5E'
        strokeWidth='3'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PlusCircle = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      stroke='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.134 1 0.999999 4.13401 1 8C1 11.866 4.134 15 8 15Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.7333 8H4.26667H11.7333ZM8 4.26667V11.7333V4.26667Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Eye = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
      />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
      />
    </svg>
  )
}

export const ClipboardAdd = ({ classes }) => {
  return (
    <svg
      className={'h-6 w-6' + classes}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
      />
    </svg>
  )
}

export const SpaceBetween = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.43092 16.0427L11.7728 20.5583L16.1146 16.0427L17.4546 17.4363L11.7728 23.3454L6.09095 17.4363L7.43092 16.0427Z'
        fill='#7E828A'
      />
      <path
        d='M16.1145 8.56018L11.7726 4.04465L7.43078 8.56018L6.09082 7.16662L11.7726 1.25753L17.4545 7.16662L16.1145 8.56018Z'
        fill='#7E828A'
      />
    </svg>
  )
}

export const Small = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.9857 12.7543C8.88057 12.1491 7.34648 11.4077 6.38341 10.5298C5.42887 9.64346 4.95159 8.55255 4.95159 7.2571C4.95159 5.79119 5.5354 4.58096 6.70301 3.62642C7.87915 2.66335 9.40472 2.18182 11.2797 2.18182C12.5581 2.18182 13.6959 2.42898 14.6931 2.92329C15.6988 3.41761 16.4743 4.09943 17.0198 4.96875C17.5738 5.83807 17.8507 6.78835 17.8507 7.8196H15.3834C15.3834 6.6946 15.0255 5.8125 14.3095 5.17329C13.5936 4.52557 12.5837 4.2017 11.2797 4.2017C10.0695 4.2017 9.12347 4.47017 8.44165 5.0071C7.76836 5.53551 7.43171 6.27273 7.43171 7.21875C7.43171 7.97727 7.75131 8.62074 8.39051 9.14915C9.03824 9.66903 10.1334 10.1463 11.676 10.581C13.2272 11.0156 14.4374 11.4972 15.3067 12.0256C16.1845 12.5455 16.8323 13.1548 17.2499 13.8537C17.676 14.5526 17.8891 15.375 17.8891 16.321C17.8891 17.8295 17.301 19.0398 16.1249 19.9517C14.9488 20.8551 13.3763 21.3068 11.4076 21.3068C10.1292 21.3068 8.93597 21.0639 7.82801 20.5781C6.72006 20.0838 5.86353 19.4105 5.25841 18.5582C4.66182 17.706 4.36353 16.7386 4.36353 15.6562H6.83086C6.83086 16.7812 7.24421 17.6719 8.07091 18.3281C8.90614 18.9759 10.0184 19.2997 11.4076 19.2997C12.703 19.2997 13.6959 19.0355 14.3863 18.5071C15.0766 17.9787 15.4218 17.2585 15.4218 16.3466C15.4218 15.4347 15.1022 14.7315 14.463 14.2372C13.8238 13.7344 12.6647 13.2401 10.9857 12.7543Z'
        fill='black'
      />
    </svg>
  )
}

export const Medium = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.89775 2.18182L11.983 17.3693L18.0682 2.18182H21.2514V20.7955H18.7969V13.5469L19.027 5.72301L12.9162 20.7955H11.037L4.93894 5.76136L5.18184 13.5469V20.7955H2.72729V2.18182H5.89775Z'
        fill='black'
      />
    </svg>
  )
}

export const Large = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.01274 18.7884L17.8338 18.7884L17.8338 20.7955L6.54541 20.7955L6.54541 2.18182L9.01274 2.18182L9.01274 18.7884Z'
        fill='black'
      />
    </svg>
  )
}

export const Section = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.25 1H4.75C3.78349 1 3 1.75551 3 2.6875V19L10 15.0625L17 19V2.6875C17 1.75551 16.2165 1 15.25 1ZM15.8333 17.0413L10 13.7601L4.16667 17.0413V2.6875C4.16667 2.37735 4.42836 2.125 4.75 2.125H15.25C15.5716 2.125 15.8333 2.37735 15.8333 2.6875V17.0413Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const SectionFilled = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.25 1H4.75C3.78349 1 3 1.75551 3 2.6875V19L10 15.0625L17 19V2.6875C17 1.75551 16.2165 1 15.25 1Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Library = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <line
        x1='3'
        y1='2.5'
        x2='3'
        y2='17.5'
        stroke='currentColor'
        strokeLinecap='round'
      />
      <line
        x1='7'
        y1='2.5'
        x2='7'
        y2='17.5'
        stroke='currentColor'
        strokeLinecap='round'
      />
      <line
        x1='10.6499'
        y1='3.27854'
        x2='16.2785'
        y2='17.3501'
        stroke='currentColor'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const Book = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.0912 3H17.0862C16.3337 3.00375 12.5627 3.27594 10.2248 4.50281C10.0983 4.56906 9.90203 4.56906 9.77547 4.50281C7.4373 3.27594 3.6663 3.00375 2.9141 3H2.9091C1.85626 3 1 3.82719 1 4.84406V14.1159C1 15.0975 1.79408 15.9059 2.80784 15.9566C3.89443 16.0116 6.62135 16.2147 8.49201 16.9056C8.6567 16.9666 8.82451 17 8.99983 17H10.9999C11.1755 17 11.3433 16.9663 11.508 16.9056C13.379 16.2147 16.1056 16.0116 17.1931 15.9566C18.2059 15.9059 19 15.0978 19 14.1163V4.84406C19.0003 3.82719 18.144 3 17.0912 3ZM9.50015 15.5312C9.50015 15.8003 9.27702 16.0041 9.02326 16.0041C8.96795 16.0041 8.91108 15.9944 8.85482 15.9734C6.90323 15.2481 4.19881 15.0256 2.85753 14.9575C2.37659 14.9334 2.00002 14.5637 2.00002 14.1159V4.84406C2.00002 4.37875 2.40815 4.00031 2.9091 4.00031C3.51161 4.00344 6.73604 4.23094 8.91295 5.19688C9.26483 5.35313 9.49546 5.68906 9.49609 6.06687L9.50015 9.20188V15.5312V15.5312ZM18.0003 14.1159C18.0003 14.5637 17.6237 14.9334 17.1425 14.9575C15.8012 15.0256 13.0968 15.2481 11.1452 15.9734C11.0889 15.9944 11.032 16.0041 10.9767 16.0041C10.7233 16.0041 10.4999 15.8003 10.4999 15.5312V9.20188L10.5039 6.06687C10.5042 5.68906 10.7352 5.35313 11.0871 5.19688C13.264 4.23094 16.4884 4.00344 17.0909 4.00031C17.5919 4.00031 18 4.37875 18 4.84406V14.1159H18.0003Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Check = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.2153 1.95621L4.05016 8.12131L1.78488 5.85602C1.67505 5.7462 1.49697 5.7462 1.38712 5.85602L0.724217 6.51893C0.614389 6.62876 0.614389 6.80684 0.724217 6.91669L3.85127 10.0437C3.9611 10.1536 4.13918 10.1536 4.24903 10.0437L11.2759 3.01688C11.3857 2.90705 11.3857 2.72897 11.2759 2.61912L10.613 1.95621C10.5032 1.84638 10.3251 1.84638 10.2153 1.95621V1.95621Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Share = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.8053 4.69928L7.68016 1.13713C7.31909 0.825295 6.75 1.07844 6.75 1.56285V3.43909C2.98526 3.48219 0 4.23672 0 7.80451C0 9.24454 0.92768 10.6711 1.95312 11.417C2.27311 11.6497 2.72916 11.3576 2.61117 10.9803C1.54842 7.58158 3.11524 6.67928 6.75 6.62699V8.6875C6.75 9.17265 7.31953 9.42468 7.68016 9.11322L11.8053 5.55072C12.0647 5.32661 12.0651 4.92369 11.8053 4.69928V4.69928Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Exit = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.09096 6.00003L10.3875 2.5661L11.0674 1.85795C11.1676 1.75349 11.1676 1.58373 11.0674 1.47927L10.34 0.721566C10.2397 0.617102 10.0767 0.617102 9.97643 0.721566L6.00004 4.86364L2.02364 0.721232C1.92336 0.616767 1.76039 0.616767 1.66011 0.721232L0.932392 1.47893C0.832106 1.5834 0.832106 1.75315 0.932392 1.85762L4.90911 6.00003L0.932392 10.1421C0.832106 10.2466 0.832106 10.4163 0.932392 10.5208L1.65978 11.2785C1.76007 11.3829 1.92303 11.3829 2.02332 11.2785L6.00004 7.13641L9.29661 10.5703L9.97643 11.2785C10.0767 11.3829 10.2397 11.3829 10.34 11.2785L11.0674 10.5208C11.1676 10.4163 11.1676 10.2466 11.0674 10.1421L7.09096 6.00003Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Favourite = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0)'>
        <path
          d='M18.0586 2.44922C15.9297 0.636724 12.7461 0.937505 10.7695 2.97657L9.99999 3.77344L9.23046 2.98047C7.63671 1.33204 4.42187 0.339849 1.9414 2.44922C-0.511728 4.54297 -0.640634 8.30079 1.55468 10.5664L9.11327 18.3711C9.35546 18.6211 9.67577 18.75 9.99608 18.75C10.3164 18.75 10.6367 18.625 10.8789 18.3711L18.4375 10.5664C20.6406 8.30079 20.5117 4.54297 18.0586 2.44922V2.44922ZM17.5469 9.69923L10.0156 17.5039L2.45312 9.69923C0.953116 8.15235 0.640616 5.20313 2.7539 3.40235C4.89452 1.57422 7.41015 2.89844 8.33202 3.85157L9.99999 5.57422L11.668 3.85157C12.5742 2.91407 15.1133 1.58594 17.2461 3.40235C19.3555 5.19922 19.0469 8.14844 17.5469 9.69923Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Home = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.8948 9.16068L10.7077 3.22275C10.5066 3.07861 10.2561 3 9.9978 3C9.7395 3 9.48897 3.07861 9.28791 3.22275L1.10359 9.16068C1.04585 9.2025 1.00913 9.26297 1.00149 9.32882C0.993841 9.39467 1.01589 9.46053 1.0628 9.51196L1.41792 9.8998C1.46479 9.95089 1.53246 9.98346 1.60621 9.99043C1.67996 9.99739 1.75382 9.97819 1.81172 9.93699L3.24838 8.89379V16.4881C3.24838 16.6207 3.30765 16.7479 3.41315 16.8417C3.51866 16.9354 3.66175 16.9881 3.81095 16.9881H8.3115C8.46071 16.9881 8.6038 16.9354 8.7093 16.8417C8.8148 16.7479 8.87407 16.6207 8.87407 16.4881V12.4878L11.1243 12.4972V16.5C11.1243 16.6326 11.1836 16.7598 11.2891 16.8535C11.3946 16.9473 11.5377 17 11.6869 17L16.1875 16.9897C16.3367 16.9897 16.4798 16.937 16.5853 16.8432C16.6908 16.7495 16.75 16.6223 16.75 16.4897V8.89379L18.1867 9.93699C18.2446 9.97878 18.3187 9.99844 18.3929 9.99164C18.4671 9.98484 18.5352 9.95214 18.5823 9.90073L18.9374 9.51289C18.9607 9.48731 18.9781 9.45789 18.9885 9.42632C18.999 9.39475 19.0023 9.36166 18.9984 9.32893C18.9944 9.29621 18.9833 9.2645 18.9655 9.23563C18.9477 9.20676 18.9237 9.18129 18.8948 9.16068V9.16068ZM15.621 15.9921H15.6246L12.2491 16.0015V11.9959C12.2487 11.8637 12.1895 11.737 12.0845 11.6433C11.9795 11.5497 11.8371 11.4967 11.6883 11.4959L8.31291 11.4874C8.23888 11.4872 8.16554 11.5 8.09708 11.525C8.02863 11.5501 7.9664 11.5869 7.91398 11.6333C7.86155 11.6798 7.81996 11.735 7.79157 11.7957C7.76319 11.8565 7.74858 11.9217 7.74858 11.9874V15.9921H4.37352V8.07779L9.99921 3.99718L15.6249 8.07779L15.621 15.9921Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Classes = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.3 9.14286C17.5431 9.14286 18.55 8.18393 18.55 7C18.55 5.81607 17.5431 4.85714 16.3 4.85714C15.0569 4.85714 14.05 5.81607 14.05 7C14.05 8.18393 15.0569 9.14286 16.3 9.14286ZM16.3 5.71429C17.0453 5.71429 17.65 6.29018 17.65 7C17.65 7.70982 17.0453 8.28571 16.3 8.28571C15.5547 8.28571 14.95 7.70982 14.95 7C14.95 6.29018 15.5547 5.71429 16.3 5.71429ZM10 10C11.7409 10 13.15 8.65804 13.15 7C13.15 5.34196 11.7409 4 10 4C8.25906 4 6.85 5.34196 6.85 7C6.85 8.65804 8.25906 10 10 10ZM10 4.85714C11.2403 4.85714 12.25 5.81875 12.25 7C12.25 8.18125 11.2403 9.14286 10 9.14286C8.75969 9.14286 7.75 8.18125 7.75 7C7.75 5.81875 8.75969 4.85714 10 4.85714ZM16.8625 10H15.7375C15.31 10 14.9134 10.1286 14.5816 10.3455C14.8459 10.517 15.085 10.7179 15.2959 10.9455C15.4337 10.8893 15.5828 10.8571 15.7375 10.8571H16.8625C17.5431 10.8571 18.1 11.433 18.1 12.1429C18.1 12.3786 18.3025 12.5714 18.55 12.5714C18.7975 12.5714 19 12.3786 19 12.1429C19 10.9616 18.0409 10 16.8625 10V10ZM3.7 9.14286C4.94312 9.14286 5.95 8.18393 5.95 7C5.95 5.81607 4.94312 4.85714 3.7 4.85714C2.45687 4.85714 1.45 5.81607 1.45 7C1.45 8.18393 2.45687 9.14286 3.7 9.14286ZM3.7 5.71429C4.44531 5.71429 5.05 6.29018 5.05 7C5.05 7.70982 4.44531 8.28571 3.7 8.28571C2.95469 8.28571 2.35 7.70982 2.35 7C2.35 6.29018 2.95469 5.71429 3.7 5.71429ZM12.2528 10.5357C11.3134 10.5357 11.08 10.8571 10 10.8571C8.92 10.8571 8.68656 10.5357 7.74719 10.5357C6.72625 10.5357 5.73344 10.9696 5.15125 11.792C4.8025 12.2848 4.6 12.8768 4.6 13.5143V14.7143C4.6 15.4241 5.20469 16 5.95 16H14.05C14.7953 16 15.4 15.4241 15.4 14.7143V13.5143C15.4 12.8768 15.1975 12.2848 14.8487 11.792C14.2666 10.9696 13.2737 10.5357 12.2528 10.5357V10.5357ZM14.5 14.7143C14.5 14.95 14.2975 15.1429 14.05 15.1429H5.95C5.7025 15.1429 5.5 14.95 5.5 14.7143V13.5143C5.5 13.0696 5.63781 12.6384 5.89656 12.2714C6.28469 11.7223 6.97656 11.3929 7.74437 11.3929C8.515 11.3929 8.79062 11.7143 10 11.7143C11.2094 11.7143 11.485 11.3929 12.2528 11.3929C13.0206 11.3929 13.7125 11.7223 14.1006 12.2714C14.3594 12.6384 14.4972 13.0696 14.4972 13.5143V14.7143H14.5ZM5.41844 10.3455C5.08375 10.1286 4.68719 10 4.2625 10H3.1375C1.95906 10 1 10.9616 1 12.1429C1 12.3786 1.2025 12.5714 1.45 12.5714C1.6975 12.5714 1.9 12.3786 1.9 12.1429C1.9 11.433 2.45687 10.8571 3.1375 10.8571H4.2625C4.41719 10.8571 4.56625 10.8893 4.70406 10.9455C4.915 10.7179 5.15688 10.517 5.41844 10.3455V10.3455Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Shevron = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.1756 0.16325L2.63422 0.69358C2.50609 0.819098 2.50609 1.02262 2.63422 1.14816L7.57521 5.99983L2.63425 10.8515C2.50612 10.977 2.50612 11.1806 2.63425 11.3061L3.17563 11.8364C3.30376 11.962 3.51152 11.962 3.63968 11.8364L9.36581 6.22711C9.49395 6.10159 9.49395 5.89807 9.36581 5.77253L3.63965 0.16325C3.51149 0.0377054 3.30373 0.0377054 3.1756 0.16325Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Clock = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 14.5625C11.6244 14.5625 14.5625 11.6244 14.5625 8C14.5625 4.37563 11.6244 1.4375 8 1.4375C4.37563 1.4375 1.4375 4.37563 1.4375 8C1.4375 11.6244 4.37563 14.5625 8 14.5625Z'
        stroke='currentColor'
        strokeWidth='0.8'
      />
      <path
        d='M8 3.1875V8.21875L10.8438 9.75'
        stroke='currentColor'
        strokeWidth='0.8'
      />
    </svg>
  )
}

export const DokletPlaceholder = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='161'
      height='161'
      viewBox='0 0 161 161'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='161' height='161' rx='80.5' fill='#3A3A3A' />
      <path
        d='M24 70.3263V90.4364C27.4285 90.7034 30.0077 90.7924 32.6813 90.7924C42.8095 90.7924 47.0872 87.7076 47.0872 80.3814C47.0872 73.1441 42.6207 70 32.6813 70C30.165 70 26.9881 70.089 24 70.3263ZM33.4362 74.5085C38.4688 74.5085 40.5448 76.1398 40.5448 80.3814C40.5448 84.5636 38.6261 86.3432 33.4362 86.3432C32.2095 86.3432 31.2973 86.3136 30.2279 86.2542V74.6271C31.2973 74.5381 32.2409 74.5085 33.4362 74.5085Z'
        fill='#F8F8F8'
      />
      <path
        d='M48.982 83.7331C48.982 88.0932 51.4984 91 58.3553 91C65.2123 91 67.7286 88.0932 67.7286 83.7331C67.7286 79.3729 65.2123 76.4661 58.3553 76.4661C51.4984 76.4661 48.982 79.3729 48.982 83.7331ZM58.3553 80.2034C60.7773 80.2034 61.7838 81.4492 61.7838 83.7627C61.7838 86.0763 60.7773 87.2924 58.3553 87.2924C55.9648 87.2924 54.9583 86.0763 54.9583 83.7627C54.9583 81.4492 55.9648 80.2034 58.3553 80.2034Z'
        fill='#F8F8F8'
      />
      <path
        d='M75.9811 70.1186H70.1621V90.4661H75.9811V87.2627L78.6232 85.3051L81.0452 87.8856C83.1211 90.1102 85.3229 90.4958 89.1603 90.4958L89.4434 86.2542C87.1158 86.2246 85.9205 85.7797 84.4422 84.2076L82.6808 82.2797L89.6006 77.0297H82.0517L75.9811 81.9237V70.1186Z'
        fill='#F8F8F8'
      />
      <path
        d='M97.3906 70.1186H91.5717V84.6822C91.5717 89.0424 93.7105 90.6144 97.8625 90.6144C98.6488 90.6144 99.4981 90.5847 100.442 90.4661V86.1653C100.159 86.1949 99.8441 86.2246 99.5924 86.2246C97.831 86.2246 97.3906 85.3644 97.3906 83.7331V70.1186Z'
        fill='#F8F8F8'
      />
      <path
        d='M107.64 84.8305H120.316C120.284 78.7797 117.328 76.4958 111.194 76.4958C104.652 76.4958 101.569 79.3729 101.569 83.7627C101.569 88.1229 104.62 91 110.722 91C114.308 91 117.768 90.5254 120.158 87.8559L115.945 86.0171C114.654 87.253 113.647 87.5 111.634 87.5C109.464 87.5 108.049 86.6102 107.64 84.8305ZM111.446 79.6695C113.207 79.6695 114.497 80.3517 114.654 82.1314H107.766C108.237 80.5297 109.527 79.6695 111.446 79.6695Z'
        fill='#F8F8F8'
      />
      <path
        d='M121.147 77.0297V80.6186H123.789V84.3856C123.789 88.7754 125.991 91 131.087 91C133.1 91 135.27 90.5847 137 89.7542L136.088 85.928C135.144 86.4915 133.886 86.9068 132.754 86.9068C130.458 86.9068 129.671 85.6907 129.671 83.4661V80.6186H136.214V77.0297H129.671V71.6907L123.789 72.8178V77.0297H121.147Z'
        fill='#F8F8F8'
      />
    </svg>
  )
}

export const Filter = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.7487 0H1.25148C0.141131 0 -0.419103 1.34715 0.367577 2.13387L7.5 9.26777V16.5625C7.49999 16.7407 7.53808 16.9168 7.6117 17.079C7.68532 17.2413 7.79278 17.3859 7.92687 17.5032L10.4269 19.69C11.2252 20.3886 12.5 19.8338 12.5 18.7493V9.26777L19.6326 2.13387C20.4178 1.34875 19.8613 0 18.7487 0ZM11.25 8.75V18.75L8.75 16.5625V8.75L1.25 1.25H18.75L11.25 8.75Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const TrashCan = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='18'
      height='18'
      viewBox='0 0 14 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.4287 2.75002H10.3335L9.33349 1.29169C9.20043 1.09763 9.02788 0.940125 8.82951 0.831645C8.63115 0.723164 8.41242 0.666687 8.19064 0.666687L5.80969 0.666687C5.58791 0.666687 5.36917 0.723164 5.17081 0.831645C4.97244 0.940125 4.7999 1.09763 4.66683 1.29169L3.66683 2.75002H0.571591C0.508445 2.75002 0.447884 2.77746 0.403233 2.82629C0.358581 2.87513 0.333496 2.94137 0.333496 3.01044L0.333496 3.53127C0.333496 3.60034 0.358581 3.66658 0.403233 3.71541C0.447884 3.76425 0.508445 3.79169 0.571591 3.79169H1.13409L2.12219 15.9108C2.15414 16.2994 2.31784 16.6608 2.58109 16.9241C2.84435 17.1873 3.18812 17.3333 3.54481 17.3334H10.4555C10.8122 17.3333 11.156 17.1873 11.4192 16.9241C11.6825 16.6608 11.8462 16.2994 11.8781 15.9108L12.8662 3.79169H13.4287C13.4919 3.79169 13.5524 3.76425 13.5971 3.71541C13.6417 3.66658 13.6668 3.60034 13.6668 3.53127V3.01044C13.6668 2.94137 13.6417 2.87513 13.5971 2.82629C13.5524 2.77746 13.4919 2.75002 13.4287 2.75002ZM5.42873 1.91669C5.47325 1.85219 5.5308 1.79982 5.59688 1.76368C5.66297 1.72754 5.7358 1.7086 5.80969 1.70835H8.19064C8.26452 1.7086 8.33736 1.72754 8.40344 1.76368C8.46953 1.79982 8.52708 1.85219 8.57159 1.91669L9.14302 2.75002H4.85731L5.42873 1.91669ZM10.9287 15.8164C10.9189 15.9462 10.8648 16.0672 10.7771 16.1553C10.6894 16.2433 10.5746 16.292 10.4555 16.2917H3.54481C3.42575 16.292 3.31093 16.2433 3.22323 16.1553C3.13554 16.0672 3.08139 15.9462 3.07159 15.8164L2.08945 3.79169H11.9109L10.9287 15.8164Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const File = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.60547 10.0039C9.41016 9.37891 9.41406 8.17188 9.52734 8.17188C9.85547 8.17188 9.82422 9.61328 9.60547 10.0039ZM9.53906 11.8477C9.23828 12.6367 8.86328 13.5391 8.42969 14.2969C9.14453 14.0234 9.95312 13.625 10.8867 13.4414C10.3906 13.0664 9.91406 12.5273 9.53906 11.8477ZM5.86328 16.7227C5.86328 16.7539 6.37891 16.5117 7.22656 15.1523C6.96484 15.3984 6.08984 16.1094 5.86328 16.7227ZM12.1875 6.25H17.5V19.0625C17.5 19.582 17.082 20 16.5625 20H3.4375C2.91797 20 2.5 19.582 2.5 19.0625V0.9375C2.5 0.417969 2.91797 0 3.4375 0H11.25V5.3125C11.25 5.82812 11.6719 6.25 12.1875 6.25ZM11.875 12.9609C11.0938 12.4844 10.5742 11.8281 10.207 10.8594C10.3828 10.1367 10.6602 9.03906 10.4492 8.35156C10.2656 7.20312 8.79297 7.31641 8.58203 8.08594C8.38672 8.80078 8.56641 9.80859 8.89844 11.0938C8.44531 12.1719 7.77734 13.6172 7.30469 14.4453C7.30078 14.4453 7.30078 14.4492 7.29688 14.4492C6.23828 14.9922 4.42188 16.1875 5.16797 17.1055C5.38672 17.375 5.79297 17.4961 6.00781 17.4961C6.70703 17.4961 7.40234 16.793 8.39453 15.082C9.40234 14.75 10.5078 14.3359 11.4805 14.1758C12.3281 14.6367 13.3203 14.9375 13.9805 14.9375C15.1211 14.9375 15.1992 13.6875 14.75 13.2422C14.207 12.7109 12.6289 12.8633 11.875 12.9609ZM17.2266 4.10156L13.3984 0.273438C13.2227 0.0976562 12.9844 0 12.7344 0H12.5V5H17.5V4.76172C17.5 4.51562 17.4023 4.27734 17.2266 4.10156ZM14.332 14.0742C14.4922 13.9687 14.2344 13.6094 12.6602 13.7227C14.1094 14.3398 14.332 14.0742 14.332 14.0742Z'
        fill='currentColor'
      />
      <rect x='4' y='7' width='12' height='11' fill='currentColor' />
    </svg>
  )
}

export const Comment = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='18'
      viewBox='0 0 20 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 1.5C14.8242 1.5 18.75 4.58594 18.75 8.375C18.75 12.1641 14.8242 15.25 10 15.25C8.89456 15.25 7.80081 15.082 6.75003 14.75L6.15628 14.5625L5.64847 14.9219C4.75003 15.5586 3.36331 16.3008 1.64065 16.4688C2.1094 15.8789 2.80472 14.8906 3.2344 13.75L3.51175 13.0195L2.97659 12.4492C1.84769 11.2539 1.25003 9.84375 1.25003 8.375C1.25003 4.58594 5.17581 1.5 10 1.5ZM10 0.25C4.47659 0.25 2.90312e-05 3.88672 2.90312e-05 8.375C2.90312e-05 10.2344 0.777373 11.9375 2.06644 13.3086C1.4844 14.8477 0.273467 16.1523 0.253935 16.168C-0.00387722 16.4414 -0.0741897 16.8398 0.0742478 17.1836C0.222685 17.5273 0.558623 17.75 0.933623 17.75C3.33597 17.75 5.2305 16.7461 6.36722 15.9414C7.50003 16.2969 8.71878 16.5 10 16.5C15.5235 16.5 20 12.8633 20 8.375C20 3.88672 15.5235 0.25 10 0.25Z'
        fill='white'
      />
    </svg>
  )
}

export const Search = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1231_25395)'>
        <path
          d='M19.8633 18.8125L14.8242 13.7734C14.7344 13.6836 14.6172 13.6367 14.4922 13.6367H14.0898C15.4297 12.1875 16.25 10.2539 16.25 8.125C16.25 3.63672 12.6133 0 8.125 0C3.63672 0 0 3.63672 0 8.125C0 12.6133 3.63672 16.25 8.125 16.25C10.2539 16.25 12.1875 15.4297 13.6367 14.0938V14.4922C13.6367 14.6172 13.6875 14.7344 13.7734 14.8242L18.8125 19.8633C18.9961 20.0469 19.293 20.0469 19.4766 19.8633L19.8633 19.4766C20.0469 19.293 20.0469 18.9961 19.8633 18.8125ZM8.125 15C4.32422 15 1.25 11.9258 1.25 8.125C1.25 4.32422 4.32422 1.25 8.125 1.25C11.9258 1.25 15 4.32422 15 8.125C15 11.9258 11.9258 15 8.125 15Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1231_25395'>
          <rect width='20' height='20' fill='currentColor' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Key = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.2969 2.74129C14.5263 1.97553 13.507 1.50966 12.4228 1.4276C11.3386 1.34553 10.2607 1.65265 9.38316 2.29366C8.50565 2.93466 7.88625 3.86741 7.63652 4.9239C7.38679 5.98039 7.52315 7.09119 8.02103 8.05621L5.99291 10.0556V11.0174H4.47181V12.5359H2.95072V14.0545H1.93666L1.42963 14.5607V16.5854H3.45775L9.99846 10.005C10.9641 10.4864 12.0693 10.6105 13.118 10.3553C14.1666 10.1001 15.0906 9.48212 15.726 8.61109C16.3614 7.74006 16.6669 6.67239 16.5884 5.59774C16.5098 4.52308 16.0522 3.51101 15.2969 2.74129V2.74129ZM13.8012 5.65184C13.6588 5.79187 13.4781 5.88675 13.2818 5.92456C13.0855 5.96237 12.8824 5.94142 12.698 5.86435C12.5136 5.78727 12.3562 5.65751 12.2454 5.49136C12.1347 5.32521 12.0756 5.1301 12.0756 4.93053C12.0756 4.73096 12.1347 4.53585 12.2454 4.3697C12.3562 4.20356 12.5136 4.07379 12.698 3.99672C12.8824 3.91964 13.0855 3.89869 13.2818 3.9365C13.4781 3.97431 13.6588 4.06919 13.8012 4.20922C13.897 4.30342 13.9731 4.41571 14.025 4.53954C14.077 4.66337 14.1037 4.79628 14.1037 4.93053C14.1037 5.06478 14.077 5.19769 14.025 5.32152C13.9731 5.44536 13.897 5.55764 13.8012 5.65184Z'
        stroke='white'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ExamsBoard = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.3262 15.6398C17.3262 16.0154 17.0215 16.3198 16.6459 16.3198H5.91013C5.53453 16.3198 5.22988 16.0154 5.22988 15.6398C5.22988 15.2642 5.53453 14.9597 5.91013 14.9597H16.6459C17.0215 14.9597 17.3262 15.2642 17.3262 15.6398ZM18.8268 15.6398C18.8268 12.7864 21.1484 10.4648 24.0018 10.4648C26.8552 10.4648 29.1766 12.7864 29.1766 15.6398C29.1766 18.4932 26.8552 20.8143 24.0018 20.8143C21.1484 20.8143 18.8268 18.4932 18.8268 15.6398ZM20.1872 15.6398C20.1872 17.7431 21.8984 19.4543 24.0017 19.4543C26.1051 19.4543 27.8161 17.7431 27.8161 15.6398C27.8161 13.5364 26.1051 11.8249 24.0017 11.8249C21.8984 11.8249 20.1872 13.5364 20.1872 15.6398ZM23.0934 17.4114C23.2263 17.5443 23.4002 17.6107 23.5744 17.6107C23.7486 17.6107 23.9225 17.5443 24.0554 17.4114L26.6376 14.8293C26.9031 14.564 26.9031 14.133 26.6376 13.8677C26.3719 13.6021 25.9413 13.6021 25.6756 13.8677L23.5745 15.9687L22.3277 14.7221C22.062 14.4565 21.6314 14.4565 21.3658 14.7221C21.1002 14.9874 21.1002 15.4184 21.3658 15.6837L23.0934 17.4114ZM16.6459 27.3771H5.91013C5.53453 27.3771 5.22988 27.6815 5.22988 28.0571C5.22988 28.4327 5.53453 28.7372 5.91013 28.7372H16.6459C17.0215 28.7372 17.3262 28.4327 17.3262 28.0571C17.3262 27.6815 17.0215 27.3771 16.6459 27.3771ZM18.8268 28.0571C18.8268 25.2037 21.1484 22.8826 24.0018 22.8826C26.8552 22.8826 29.1766 25.2037 29.1766 28.0571C29.1766 30.9105 26.8552 33.2321 24.0018 33.2321C21.1484 33.2321 18.8268 30.9105 18.8268 28.0571ZM20.1872 28.0571C20.1872 30.1605 21.8984 31.872 24.0017 31.872C26.1051 31.872 27.8161 30.1605 27.8161 28.0571C27.8161 25.9538 26.1051 24.2426 24.0017 24.2426C21.8984 24.2426 20.1872 25.9538 20.1872 28.0571ZM23.0934 29.8292C23.2263 29.962 23.4002 30.0284 23.5744 30.0284C23.7486 30.0284 23.9225 29.962 24.0554 29.8292L26.6376 27.247C26.9031 26.9817 26.9031 26.5507 26.6376 26.2855C26.3719 26.0198 25.9413 26.0198 25.6756 26.2855L23.5745 28.3864L22.3277 27.1398C22.062 26.8742 21.6314 26.8742 21.3658 27.1398C21.1002 27.4051 21.1002 27.8361 21.3658 28.1014L23.0934 29.8292ZM16.6459 39.7948H5.91013C5.53453 39.7948 5.22988 40.0992 5.22988 40.4748C5.22988 40.8504 5.53453 41.1549 5.91013 41.1549H16.6459C17.0215 41.1549 17.3262 40.8504 17.3262 40.4748C17.3262 40.0992 17.0215 39.7948 16.6459 39.7948ZM46.1467 22.4492L33.403 35.1931V45.069C33.403 46.6849 32.0882 47.9994 30.4722 47.9994H3.93429C2.31821 47.9994 1.00342 46.6849 1.00342 45.069V8.4793C1.00342 6.86305 2.31821 5.54843 3.93429 5.54843H10.158V4.53472C10.158 3.33951 11.3688 2.3673 12.8568 2.3673H13.5489V2.01544C13.5489 0.904078 14.667 0.000244141 16.0411 0.000244141H18.3652C19.7395 0.000244141 20.8576 0.904078 20.8576 2.01544V2.3673H21.5497C23.0377 2.3673 24.2483 3.33951 24.2483 4.53472V5.54843H30.4722C32.0883 5.54843 33.4031 6.863 33.4031 8.4793V26.9541L42.0278 18.3295C43.1633 17.1932 45.0113 17.1932 46.1468 18.3295C46.6956 18.8778 46.9976 19.6093 46.9976 20.3893C46.9976 21.169 46.6955 21.9008 46.1467 22.4492ZM39.5269 22.7534L28.472 33.8085C29.0058 33.9273 29.4958 34.1919 29.8902 34.5866C30.2847 34.9808 30.5492 35.4708 30.668 36.0046L41.7228 24.9497C42.3281 24.3444 42.3283 23.3589 41.723 22.7536C41.1177 22.1492 40.1331 22.1484 39.5269 22.7534ZM27.7268 39.6617L24.2631 41.1027C24.1785 41.1379 24.09 41.1548 24.002 41.1548C23.8249 41.1548 23.6509 41.086 23.5209 40.9555C23.3261 40.761 23.268 40.4681 23.3738 40.2134L24.815 36.7491C24.5498 36.6915 24.2784 36.6599 24.0018 36.6599C21.8984 36.6599 20.1873 38.3714 20.1873 40.4748C20.1873 42.5781 21.8984 44.2893 24.0018 44.2893C26.1051 44.2893 27.8161 42.5781 27.8161 40.4748C27.8161 40.1985 27.7844 39.9271 27.7268 39.6617ZM29.0119 37.6539C29.2503 37.3743 29.3804 37.0209 29.3804 36.6461C29.3804 36.2298 29.2198 35.8399 28.9283 35.5485C28.3744 34.9939 27.4126 34.961 26.8227 35.4647L25.2632 39.2132L29.0119 37.6539ZM11.5185 7.30702C11.5185 7.68816 12.0908 8.11475 12.8568 8.11475H21.5497C22.3156 8.11475 22.8878 7.68816 22.8878 7.30702V4.53472C22.8878 4.15358 22.3155 3.72737 21.5497 3.72737H20.1774C19.8018 3.72737 19.4971 3.42293 19.4971 3.04734V2.01544C19.4971 1.70625 19.013 1.36031 18.3652 1.36031H16.041C15.3932 1.36031 14.9093 1.70625 14.9093 2.01544V3.04734C14.9093 3.42293 14.6046 3.72737 14.229 3.72737H12.8567C12.0907 3.72737 11.5184 4.15358 11.5184 4.53472L11.5185 7.30702ZM32.0426 36.5536L29.8903 38.706C29.8583 38.7379 29.8233 38.7664 29.7858 38.7913C29.7641 38.8058 29.7406 38.8161 29.7177 38.8279C29.7018 38.836 29.6871 38.8463 29.6706 38.8531L29.6666 38.8548C29.6657 38.8551 29.6649 38.8555 29.6641 38.8558L28.9954 39.134C29.1122 39.5693 29.1766 40.0173 29.1766 40.4749C29.1766 43.3283 26.8552 45.6494 24.0018 45.6494C21.1485 45.6494 18.8269 43.3283 18.8269 40.4749C18.8269 37.6215 21.1485 35.2999 24.0018 35.2999C24.4597 35.2999 24.9076 35.3643 25.3427 35.4809L25.6234 34.8061C25.6313 34.7873 25.6427 34.7705 25.6521 34.7526C25.663 34.7319 25.6722 34.7106 25.6853 34.6909C25.7102 34.6535 25.7386 34.6185 25.7705 34.5866L32.0426 28.3146V8.4793C32.0426 7.61307 31.3383 6.9085 30.4723 6.9085H24.2484V7.30702C24.2484 8.50223 23.0377 9.47482 21.5498 9.47482H12.8568C11.3689 9.47482 10.158 8.50223 10.158 7.30702V6.9085H3.93434C3.06827 6.9085 2.36397 7.61307 2.36397 8.4793V45.069C2.36397 45.9348 3.06833 46.6394 3.93434 46.6394H30.4722C31.3383 46.6394 32.0426 45.9348 32.0426 45.069L32.0426 36.5536ZM45.6372 20.3894C45.6372 19.9726 45.4766 19.5828 45.1852 19.291C44.5796 18.6861 43.5951 18.6861 42.9894 19.291L41.2665 21.0139C41.7864 21.1306 42.2809 21.3882 42.6845 21.7921C43.079 22.1866 43.3435 22.6765 43.4623 23.2102L45.1852 21.4873C45.4766 21.1955 45.6372 20.8056 45.6372 20.3894Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const ExamsExitTicket = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.9274 0.343567C9.01125 1.10872 9.37459 1.816 9.94776 2.32979C10.5209 2.84358 11.2636 3.12771 12.0333 3.12771C12.8031 3.12771 13.5457 2.84358 14.1189 2.32979C14.6921 1.816 15.0554 1.10872 15.1393 0.343567H19.6221V23.59H15.1393C15.0554 22.8249 14.6921 22.1176 14.1189 21.6038C13.5457 21.09 12.8031 20.8059 12.0333 20.8059C11.2636 20.8059 10.5209 21.09 9.94776 21.6038C9.37459 22.1176 9.01125 22.8249 8.9274 23.59H4.44461V0.343567H8.9274Z'
        stroke='#202020'
        strokeWidth='0.90566'
        strokeMiterlimit='10'
      />
      <path
        d='M19.4717 17.8535H4.98114'
        stroke='#202020'
        strokeWidth='0.90566'
        strokeDasharray='1.36 1.36'
      />
      <path
        d='M12.2264 4.98096L11.5147 7.17124H9.21173L11.0749 8.52491L10.3632 10.7152L12.2264 9.36153L14.0896 10.7152L13.3779 8.52491L15.2411 7.17124H12.9381L12.2264 4.98096Z'
        stroke='#202020'
        strokeWidth='0.90566'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ExamPassedCheckmark = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='53'
      height='53'
      viewBox='0 0 53 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='26.5'
        cy='26.5'
        r='26.5'
        transform='matrix(-1 0 0 1 53 0)'
        fill='#5F9B56'
      />
      <rect
        x='24.6223'
        y='33.5281'
        width='2.65'
        height='13.4329'
        transform='rotate(135 24.6223 33.5281)'
        fill='white'
      />
      <rect
        x='38.5159'
        y='15.9'
        width='2.65'
        height='24.5874'
        transform='rotate(45 38.5159 15.9)'
        fill='white'
      />
    </svg>
  )
}

export const ExamFailedCross = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='53'
      height='53'
      viewBox='0 0 53 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='26.5'
        cy='26.5'
        r='26.5'
        transform='matrix(-1 0 0 1 53 0)'
        fill='#CD2828'
      />
      <rect
        x='38.386'
        y='36.5126'
        width='2.65'
        height='29.15'
        transform='rotate(135 38.386 36.5126)'
        fill='white'
      />
      <rect
        x='36.512'
        y='15.9'
        width='2.65'
        height='29.15'
        transform='rotate(45 36.512 15.9)'
        fill='white'
      />
    </svg>
  )
}

export const HeartFilled = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.2533 2.09635C15.3373 0.439204 12.472 0.714206 10.6931 2.5785L10.0005 3.30707L9.30793 2.58207C7.87355 1.07493 4.98016 0.167774 2.74772 2.09635C0.539879 4.01065 0.423863 7.44639 2.39966 9.51781L9.20246 16.6536C9.42043 16.8821 9.70872 17 9.997 17C10.2853 17 10.5736 16.8857 10.7915 16.6536L17.5944 9.51781C19.5772 7.44639 19.4611 4.01065 17.2533 2.09635Z'
        fill='#45908D'
      />
    </svg>
  )
}

export const HeartOutline = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.2533 2.09635C15.3373 0.439204 12.472 0.714206 10.6931 2.5785L10.0005 3.30707L9.30793 2.58207C7.87355 1.07493 4.98016 0.167774 2.74772 2.09635C0.539879 4.01065 0.423863 7.44639 2.39966 9.51781L9.20246 16.6536C9.42044 16.8821 9.70872 17 9.997 17C10.2853 17 10.5736 16.8857 10.7915 16.6536L17.5944 9.51781C19.5772 7.44639 19.4611 4.01065 17.2533 2.09635ZM16.7928 8.72497L10.0146 15.8607L3.20827 8.72497C1.85825 7.31067 1.577 4.61423 3.47897 2.96779C5.40555 1.29635 7.66964 2.50707 8.49933 3.37851L10.0005 4.95351L11.5017 3.37851C12.3173 2.52136 14.6025 1.30706 16.5221 2.96779C18.4206 4.61065 18.1428 7.3071 16.7928 8.72497Z'
        fill='#242424'
      />
    </svg>
  )
}

export const MarkAsDoneCheck = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='10'
        cy='10'
        r='10'
        transform='matrix(-1 0 0 1 20 0)'
        fill='white'
      />
      <rect
        x='9.29144'
        y='12.6521'
        width='1'
        height='5.06904'
        transform='rotate(135 9.29144 12.6521)'
        fill='#45908D'
      />
      <rect
        x='14.5342'
        y='6'
        width='1'
        height='9.27827'
        transform='rotate(45 14.5342 6)'
        fill='#45908D'
      />
    </svg>
  )
}

export const UndoArrow = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.86879 14.1374C3.72606 12.9072 3.89814 11.6608 4.36887 10.5153C4.8396 9.36976 5.59357 8.36254 6.56006 7.58812C7.52656 6.81369 8.67391 6.29743 9.89451 6.08775C11.1151 5.87806 12.369 5.98183 13.5385 6.38931C14.708 6.7968 15.7549 7.49465 16.581 8.41741C17.407 9.34018 17.9851 10.4576 18.2612 11.665C18.5372 12.8723 18.502 14.13 18.159 15.32C17.816 16.51 17.1763 17.5935 16.3 18.4686'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.5625 11.0437L3.8125 14.4187L6.93438 11.6062'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PadLock = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.4001 1.49994C9.49837 1.49994 8.63357 1.85815 7.99595 2.49578C7.35832 3.1334 7.00011 3.9982 7.00011 4.89994V9.39994C7.00011 9.67608 6.77625 9.89994 6.50011 9.89994C6.22397 9.89994 6.00011 9.67608 6.00011 9.39994V4.89994C6.00011 3.73299 6.46368 2.61383 7.28884 1.78867C8.114 0.963509 9.23316 0.499939 10.4001 0.499939C11.5671 0.499939 12.6862 0.963509 13.5114 1.78867C14.3365 2.61383 14.8001 3.73299 14.8001 4.89994V9.39994C14.8001 9.67608 14.5763 9.89994 14.3001 9.89994C14.024 9.89994 13.8001 9.67608 13.8001 9.39994V4.89994C13.8001 3.9982 13.4419 3.1334 12.8043 2.49578C12.1666 1.85815 11.3018 1.49994 10.4001 1.49994Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.59999 9.90006C4.88202 9.90006 4.29999 10.4821 4.29999 11.2001V17.2001C4.29999 17.918 4.88202 18.5001 5.59999 18.5001H15.2C15.918 18.5001 16.5 17.918 16.5 17.2001V11.2001C16.5 10.4821 15.918 9.90006 15.2 9.90006H5.59999ZM3.29999 11.2001C3.29999 9.92981 4.32973 8.90006 5.59999 8.90006H15.2C16.4702 8.90006 17.5 9.92981 17.5 11.2001V17.2001C17.5 18.4703 16.4702 19.5001 15.2 19.5001H5.59999C4.32973 19.5001 3.29999 18.4703 3.29999 17.2001V11.2001Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.29999 11.2001C4.29999 10.4821 4.88202 9.90006 5.59999 9.90006H15.2C15.918 9.90006 16.5 10.4821 16.5 11.2001V17.2001C16.5 17.918 15.918 18.5001 15.2 18.5001H5.59999C4.88202 18.5001 4.29999 17.918 4.29999 17.2001V11.2001ZM10.4 12.2C10.6762 12.2 10.9 12.4238 10.9 12.7V15.7C10.9 15.9761 10.6762 16.2 10.4 16.2C10.1239 16.2 9.90002 15.9761 9.90002 15.7V12.7C9.90002 12.4238 10.1239 12.2 10.4 12.2Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const SectionTagNoExams = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.19447 17.8147L2.5 22.9824V0.5H16.5V22.9824L9.80553 17.8147L9.5 17.5789L9.19447 17.8147Z'
        stroke='white'
      />
    </svg>
  )
}

export const SectionTagHasExamsNoAttempts = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.19447 17.8147L2.5 22.9824V0.5H16.5V22.9824L9.80553 17.8147L9.5 17.5789L9.19447 17.8147Z'
        stroke='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13 8H6V7H13V8Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const SectionTagHasExamsHasAttempts = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M2 0H17V24L9.5 18.2105L2 24V0Z' fill='#D6D6D6' />
    </svg>
  )
}

export const SectionTagPassedCheckmark = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.19447 17.8147L2.5 22.9824V0.5H16.5V22.9824L9.80553 17.8147L9.5 17.5789L9.19447 17.8147Z'
        fill='#5F9B56'
        stroke='#5F9B56'
      />
      <rect
        x='12.8285'
        y='5.48511'
        width='1'
        height='6.82842'
        transform='rotate(45 12.8285 5.48511)'
        fill='white'
      />
      <rect
        x='5.85999'
        y='8.22363'
        width='1'
        height='3.95537'
        transform='rotate(-45 5.85999 8.22363)'
        fill='white'
      />
      <rect
        x='12.8285'
        y='5.48511'
        width='1'
        height='6.82842'
        transform='rotate(45 12.8285 5.48511)'
        fill='white'
      />
      <rect
        x='5.85999'
        y='8.22363'
        width='1'
        height='3.95537'
        transform='rotate(-45 5.85999 8.22363)'
        fill='white'
      />
    </svg>
  )
}

export const SectionTagFailedCross = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='24'
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M2 0H17V24L9.5 18.2105L2 24V0Z' fill='#CD2828' />
      <rect
        x='11.9749'
        y='5.47485'
        width='1'
        height='8'
        transform='rotate(45 11.9749 5.47485)'
        fill='white'
      />
      <rect
        x='6.31799'
        y='6.18188'
        width='1'
        height='8'
        transform='rotate(-45 6.31799 6.18188)'
        fill='white'
      />
    </svg>
  )
}

export const SectionCircleNoAttempts = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='10'
        cy='10'
        r='9.5'
        transform='matrix(-1 0 0 1 20 0)'
        stroke='currentColor'
      />
      <rect
        x='15.9644'
        y='9.74268'
        width='1'
        height='11'
        transform='rotate(90 15.9644 9.74268)'
        fill='currentColor'
      />
    </svg>
  )
}

export const SectionCircleHasAttempts = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='10'
        cy='10'
        r='10'
        transform='matrix(-1 0 0 1 20 0)'
        fill='#D6D6D6'
      />
    </svg>
  )
}

export const SectionCirclePassedCheckmark = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='10'
        cy='10'
        r='10'
        transform='matrix(-1 0 0 1 20 0)'
        fill='#5F9B56'
      />
      <rect
        x='9.2915'
        y='12.6521'
        width='1'
        height='5.06904'
        transform='rotate(135 9.2915 12.6521)'
        fill='white'
      />
      <rect
        x='14.5342'
        y='6'
        width='1'
        height='9.27827'
        transform='rotate(45 14.5342 6)'
        fill='white'
      />
    </svg>
  )
}

export const SectionCircleFailedCross = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='10'
        cy='10'
        r='10'
        transform='matrix(-1 0 0 1 20 0)'
        fill='#CD2828'
      />
      <rect
        x='14.4854'
        y='13.7783'
        width='1'
        height='11'
        transform='rotate(135 14.4854 13.7783)'
        fill='white'
      />
      <rect
        x='13.7783'
        y='6'
        width='1'
        height='11'
        transform='rotate(45 13.7783 6)'
        fill='white'
      />
    </svg>
  )
}

export const Star = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 15.1058L4.33333 18.375L5.66667 12.1635L1 7.91346L7.33333 7.25962L10 1.375L12.6667 7.25962L19 7.91346L14.3333 12.1635L15.6667 18.375L10 15.1058Z'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const FileCabinet = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5625 3.25H18.4375V6.625H1.5625V3.25ZM2.6875 6.625H17.3125V16.75H2.6875V6.625Z'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.375 8.875C13.375 9.17337 13.2565 9.45952 13.0455 9.67049C12.8345 9.88147 12.5484 10 12.25 10H7.75C7.45163 10 7.16548 9.88147 6.95451 9.67049C6.74353 9.45952 6.625 9.17337 6.625 8.875'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PaperPlane = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.33334 11.6667V17.5L10.8333 13.4444'
        stroke='currentColor'
        strokeWidth='0.833333'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5 2.5L1.66669 9.16667L8.16966 11.6667M17.5 2.5L14.9554 15.8333L8.16966 11.6667M17.5 2.5L8.16966 11.6667'
        stroke='currentColor'
        strokeWidth='0.833333'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const EmojiRatingOne = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 18.4375C14.6599 18.4375 18.4375 14.6599 18.4375 10C18.4375 5.3401 14.6599 1.5625 10 1.5625C5.3401 1.5625 1.5625 5.3401 1.5625 10C1.5625 14.6599 5.3401 18.4375 10 18.4375Z'
        fill='currentColor'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M13.9094 14.5562C13.4212 14.0049 12.8215 13.5635 12.15 13.2612C11.4785 12.9589 10.7505 12.8026 10.0141 12.8026C9.27765 12.8026 8.54963 12.9589 7.87813 13.2612C7.20664 13.5635 6.60696 14.0049 6.11874 14.5562'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M7.1875 9.4375C7.49816 9.4375 7.75 9.18566 7.75 8.875C7.75 8.56434 7.49816 8.3125 7.1875 8.3125C6.87684 8.3125 6.625 8.56434 6.625 8.875C6.625 9.18566 6.87684 9.4375 7.1875 9.4375Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M12.8125 9.4375C13.1232 9.4375 13.375 9.18566 13.375 8.875C13.375 8.56434 13.1232 8.3125 12.8125 8.3125C12.5018 8.3125 12.25 8.56434 12.25 8.875C12.25 9.18566 12.5018 9.4375 12.8125 9.4375Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M8.3125 7.3125L6.0625 6.1875M13.9375 6.1875L11.6875 7.3125'
        stroke='#202020'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const EmojiRatingTwo = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 18.4375C5.3401 18.4375 1.5625 14.6599 1.5625 10C1.5625 5.3401 5.3401 1.5625 10 1.5625C14.6599 1.5625 18.4375 5.3401 18.4375 10C18.4375 14.6599 14.6599 18.4375 10 18.4375Z'
        fill='currentColor'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M12.8125 8.875C12.5018 8.875 12.25 8.62316 12.25 8.3125C12.25 8.00184 12.5018 7.75 12.8125 7.75C13.1232 7.75 13.375 8.00184 13.375 8.3125C13.375 8.62316 13.1232 8.875 12.8125 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M7.1875 8.875C6.87684 8.875 6.625 8.62316 6.625 8.3125C6.625 8.00184 6.87684 7.75 7.1875 7.75C7.49816 7.75 7.75 8.00184 7.75 8.3125C7.75 8.62316 7.49816 8.875 7.1875 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M14 13.968C13.5868 13.6703 12.9979 13.4243 12.2921 13.2544C11.5863 13.0845 10.7885 12.9968 9.97841 13.0001C9.16834 13.0033 8.37448 13.0974 7.67628 13.2729C6.97808 13.4484 6.40003 13.6991 6 14'
        stroke='#202020'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const EmojiRatingThree = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 18.4375C5.3401 18.4375 1.5625 14.6599 1.5625 10C1.5625 5.3401 5.3401 1.5625 10 1.5625C14.6599 1.5625 18.4375 5.3401 18.4375 10C18.4375 14.6599 14.6599 18.4375 10 18.4375Z'
        fill='currentColor'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path d='M14 14L6 14' stroke='#202020' strokeMiterlimit='10' />
      <path
        d='M12.8125 8.875C12.5018 8.875 12.25 8.62316 12.25 8.3125C12.25 8.00184 12.5018 7.75 12.8125 7.75C13.1232 7.75 13.375 8.00184 13.375 8.3125C13.375 8.62316 13.1232 8.875 12.8125 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M7.1875 8.875C6.87684 8.875 6.625 8.62316 6.625 8.3125C6.625 8.00184 6.87684 7.75 7.1875 7.75C7.49816 7.75 7.75 8.00184 7.75 8.3125C7.75 8.62316 7.49816 8.875 7.1875 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const EmojiRatingFour = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 18.4375C14.6599 18.4375 18.4375 14.6599 18.4375 10C18.4375 5.3401 14.6599 1.5625 10 1.5625C5.3401 1.5625 1.5625 5.3401 1.5625 10C1.5625 14.6599 5.3401 18.4375 10 18.4375Z'
        fill='currentColor'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M14.5 12.5031C14.0352 13.2871 13.3726 13.9351 12.5786 14.3825C11.7846 14.8299 10.887 15.0609 9.97571 15.0523C9.06438 15.0438 8.17129 14.796 7.38582 14.3338C6.60034 13.8716 5.95004 13.2113 5.5 12.4188'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M7.1875 8.875C7.49816 8.875 7.75 8.62316 7.75 8.3125C7.75 8.00184 7.49816 7.75 7.1875 7.75C6.87684 7.75 6.625 8.00184 6.625 8.3125C6.625 8.62316 6.87684 8.875 7.1875 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
      <path
        d='M12.8125 8.875C13.1232 8.875 13.375 8.62316 13.375 8.3125C13.375 8.00184 13.1232 7.75 12.8125 7.75C12.5018 7.75 12.25 8.00184 12.25 8.3125C12.25 8.62316 12.5018 8.875 12.8125 8.875Z'
        stroke='#202020'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const EmojiRatingFive = ({ classes }) => {
  return (
    <svg
      className={classes}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 18.4375C14.6599 18.4375 18.4375 14.6599 18.4375 10C18.4375 5.3401 14.6599 1.5625 10 1.5625C5.3401 1.5625 1.5625 5.3401 1.5625 10C1.5625 14.6599 5.3401 18.4375 10 18.4375Z'
        fill='currentColor'
        stroke='#202020'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.0625 8.84668C6.0625 8.54831 6.18103 8.26216 6.39201 8.05118C6.60298 7.84021 6.88913 7.72168 7.1875 7.72168C7.48587 7.72168 7.77202 7.84021 7.983 8.05118C8.19397 8.26216 8.3125 8.54831 8.3125 8.84668M11.6875 8.84668C11.6875 8.54831 11.806 8.26216 12.017 8.05118C12.228 7.84021 12.5141 7.72168 12.8125 7.72168C13.1109 7.72168 13.397 7.84021 13.608 8.05118C13.819 8.26216 13.9375 8.54831 13.9375 8.84668'
        stroke='#202020'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.9375 12.25C5.55625 14.4719 7.58125 16.1875 10 16.1875C12.4188 16.1875 14.4437 14.4719 15.0625 12.25H4.9375Z'
        stroke='#202020'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
